// extracted by mini-css-extract-plugin
export var readonly = "_hm-1";
export var star = "_hm-0";